import * as React from 'react';
import { Collapse as AntdCollapse } from 'antd';
import './CollapseSimple.css';
import PropTypes from 'prop-types';

const propTypes = {
  collapsed: PropTypes.any,
  name: PropTypes.any,
  label: PropTypes.any,
  children: PropTypes.any
};

function CollapseSimple(props) {
  const activeKey = props.collapsed ? [] : ['1'];
  return (
    <div data-test={props.name}>
      <AntdCollapse className="CollapseSimple" defaultActiveKey={activeKey} bordered={false}>
        <AntdCollapse.Panel className="Collapse__content" header={props.label} key="1">
          {props.children}
        </AntdCollapse.Panel>
      </AntdCollapse>
    </div>
  );
}

CollapseSimple.propTypes = propTypes;

export default CollapseSimple;



// WEBPACK FOOTER //
// ./src/components/collapseSimple/CollapseSimple.jsx